import React, { useState } from "react";
import PendingRequestPresenter from "./PendingRequestPresenter";
import DTOPendingRequests from "./DTOPendingRequest";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";

function PendingRequestController() {
  const [pendingRequests, setPendingRequests] = useState([]);
  const { t} = useTranslation();

  const isLoading = useAppSelector(
    (state) => state.timelineSlice.timelineLoader
  );
  function callback(requests: []) {
    setPendingRequests(requests);
  }

  return (
    <>
      <DTOPendingRequests setPendingRequestsData={callback} />
      <PendingRequestPresenter
        requests={pendingRequests}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default PendingRequestController;
